"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUsageStatsOut = void 0;
class AppUsageStatsOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AppUsageStatsOut.attributeTypeMap;
    }
}
exports.AppUsageStatsOut = AppUsageStatsOut;
AppUsageStatsOut.discriminator = undefined;
AppUsageStatsOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=AppUsageStatsOut.js.map